const custom_profile_fields = {
    /** UNTRANSLATED */
    entity_not_exists_with_names: 'Cannot find entities with the given names: {{names}}',
    invalid_min_max_input: 'Input minimo e massimo non valido.',
    invalid_options: 'Opzioni del campo non valide.',
    invalid_regex_format: 'Formato regex non valido.',
    invalid_address_parts: "Parti dell'indirizzo non valide.",
    invalid_fullname_parts: 'Parti del nome completo non valide.',
    name_exists: 'Esiste già un campo con il nome fornito.',
    conflicted_sie_order: "Valore dell'ordine del campo in conflitto per Sign-in Experience.",
    /** UNTRANSLATED */
    invalid_name: 'Invalid field name, only letters or numbers are allowed, case sensitive.',
};
export default Object.freeze(custom_profile_fields);
